import { render, staticRenderFns } from "./FreetsPage.vue?vue&type=template&id=2e593616&scoped=true&"
import script from "./FreetsPage.vue?vue&type=script&lang=js&"
export * from "./FreetsPage.vue?vue&type=script&lang=js&"
import style0 from "./FreetsPage.vue?vue&type=style&index=0&id=2e593616&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e593616",
  null
  
)

export default component.exports